const CustomAlert = React.memo(function CustomAlert(props){

    const {
        title,
        body,
        error,
        closeButton,
        submitOnClose,
        buttons,
        children,
        onSubmit,
        onClose,
    } = props;

    const rootRef = React.useRef(null);
    const [top, setTop] = React.useState(0);
    const [left, setLeft] = React.useState(0);

    const submit = React.useCallback(event => {
        onSubmit();
    }, [onSubmit]);

    const close = React.useCallback(event => {
        if(submitOnClose){
            onSubmit();
        }
        onClose();
    }, [submitOnClose, onSubmit, onClose]);

    React.useEffect(() => {
        setTop((window.innerHeight / 2) - (rootRef.current.clientHeight / 2));
        setLeft((window.innerWidth / 2) - (rootRef.current.clientWidth / 2));
    }, []);

    let renderedButtons = [];
    _.each(buttons, (text, type) => {
        if(type === 'ok'){
            renderedButtons.push(<button className="customAlertButtonOk" onClick={submit} key={'button-' + text}>{text}</button>);
        }
        if(type === 'cancel'){
            renderedButtons.push(<button className="customAlertButtonOk" onClick={close} key={'button-' + text}>{text}</button>);
        }
    });

    return (
        <div className="customAlert" style={{display: 'block', top, left}} ref={rootRef}>
            <div className="customAlertInner">
                <div className="customAlertTitle">
                    {title && <span>{title}</span>}
                    {closeButton && <a className="closeAlert" href="#" onClick={onClose}/>}
                </div>
                <div className="customAlertMsg">
                    {children || body}
                </div>
                {error &&
                    <div className="customAlertError">
                        {error}
                    </div>
                }
                <div className="customAlertButtons center">
                    {renderedButtons}
                </div>
            </div>
        </div>
    );
});

CustomAlert.defaultProps = {
    title: null,
    body: null,
    error: null,
    closeButton: true,
    submitOnClose: false,
    buttons: {
        ok: 'OK',
    },
    onSubmit: () => {},
    onClose: () => {},
};

CustomAlert.displayName = 'CustomAlert';